import {DxSessionValidationStrategy} from "./dx-session-validation-strategy";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Injectable} from "@angular/core";

@Injectable()
export class DxServerDefinedValidationStrategy implements DxSessionValidationStrategy {

  constructor() { }

  public validateSession(session: DxUserSession): boolean {
    return !!session;
  }
}
